import { assertNever } from '@framework/engine/utils/assertNever.ts';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { type TagProps } from 'antd';
import styled, { type DefaultTheme, useTheme } from 'styled-components';
import { SignatureFormat } from './SignatureFormat.ts';

const StyledTagWithMargin = styled(StyledTag)`
  margin-right: 0;
  text-transform: none;
`;

/**
 * Ritorna le impostazioni per il tag in base al formato di firma.
 */
function getTagOptions(
  format: SignatureFormat,
  theme?: DefaultTheme,
): TagProps {
  switch (format) {
    case SignatureFormat.CAdES:
      return {
        color: theme?.colorSuccess ?? '#389e0d',
        children: 'CAdES',
      };
    case SignatureFormat.PAdES:
      return {
        color: theme?.colorSuccess ?? '#389e0d',
        children: 'PAdES',
      };
    case SignatureFormat.Handwritten:
      return {
        color: theme?.colorWarning ?? '#faad14',
        children: 'Autografa',
      };
  }
  assertNever(format);
}

export interface ISignatureFormatTagProps {
  format: SignatureFormat | null;
}

/**
 * Tag per il formato di firma (CAdES, PAdES, Autografa).
 */
export function SignatureFormatTag(props: Readonly<ISignatureFormatTagProps>) {
  const { format } = props;
  const theme = useTheme();
  if (!format) return null;

  return <StyledTagWithMargin {...getTagOptions(format, theme)} />;
}
